<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>CURRENCY<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="currency" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="CurrencyColumns" [selectionField]="'Currency_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addCurrency($event)" (editEntity)="editCurrency($event)"
            (refreshEntities)="refreshCurrency($event)" (deleteEntity)="deleteCurrency($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>
    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearCurrency()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Currency Name'" [formData]="entity" [maxlength]="50" [mandatory]="true"
                        [fieldName]="'CurrencyName'" [(ngModel)]="entity.CurrencyName"
                        ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'CurrencyCode'" [(ngModel)]="entity.CurrencyCode"
                        ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Symbol'" [formData]="entity" [maxlength]="2" [mandatory]="true"
                        [fieldName]="'Symbol'" [(ngModel)]="entity.Symbol" ngDefaultControl>
                    </textbox>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
            </div> -->
        </div>
        
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Currency Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="CurrencyName" class="label label-1">Currency Name : </label> {{details.CurrencyName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="CurrencyCode" class="label label-1">Code : </label> {{details.CurrencyCode}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Symbol" class="label label-1">Symbol : </label> {{details.Symbol}}
          </div>
        </div>
    </div>
    </kendo-dialog>
<kendo-excelexport [data]="currency.data" [collapsible]="true" fileName="Currency.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="CurrencyName" title="Currency" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="CurrencyCode" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Symbol" title="Symbol" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>